import { NavLink } from 'react-router-dom';
import { LogOut, FileText, Package, Settings, Users } from 'lucide-react';
import clsx from 'clsx';
import { useAuth } from '../hooks/useAuth';
import { LangSwitch, useI18n } from '../lib/i18n';

export default function Header() {
  const { user, isAdmin, logout } = useAuth();
  const { t } = useI18n();

  const navClass = ({ isActive }: { isActive: boolean }) =>
    clsx(
      'inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
      isActive ? 'bg-teal-light text-teal' : 'text-gray-600 hover:bg-teal-light hover:text-teal',
    );

  return (
    <header className="sticky top-0 z-20 border-b border-gray-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-6 px-6">
        <NavLink to="/" className="flex items-center gap-3">
          <img src="/bd-color.svg" alt="BuyDubai" className="h-7 w-auto" />
          <span className="hidden font-heading text-lg font-semibold text-dark sm:block">
            {t('nav.offers')}
          </span>
        </NavLink>

        <nav className="flex items-center gap-1">
          <NavLink to="/" end className={navClass}>
            <FileText size={16} /> {t('nav.offers')}
          </NavLink>
          {isAdmin && (
            <>
              <NavLink to="/services" className={navClass}>
                <Package size={16} /> {t('nav.catalog')}
              </NavLink>
              <NavLink to="/settings" className={navClass}>
                <Settings size={16} /> {t('nav.settings')}
              </NavLink>
              <NavLink to="/users" className={navClass}>
                <Users size={16} /> {t('nav.users')}
              </NavLink>
            </>
          )}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <LangSwitch />
          <span className="hidden text-sm text-gray-600 md:block">{user?.name}</span>
          <button onClick={logout} className="btn-ghost" title={t('nav.logout')} aria-label={t('nav.logout')}>
            <LogOut size={16} />
          </button>
        </div>
      </div>
    </header>
  );
}
